package io.github.jangalinski.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initLinksPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("links.md", FrontMatterElement.Builder { addScalar("title", "Links"); addScalar("description", "what else lies out there in the world"); addScalar("header-img", "/img/about-bg.jpg"); }))
}

@Page("/links")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun LinksPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Loose collection of links I want to remember. This page might change a lot, so when you like a link, be sure to bookmark it yourself.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("spring-boot") }) {
        org.jetbrains.compose.web.dom.Text("Spring (Boot)")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://docs.spring.io/spring-boot/docs/1.2.1.RELEASE/reference/htmlsingle/#using-boot-starter-poms") {
                org.jetbrains.compose.web.dom.Text("List of Starters")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28103852/spring-boot-session-timeout") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28103852/spring-boot-session-timeout")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28115517/configuring-springboot-to-work-with-2-different-databases") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28115517/configuring-springboot-to-work-with-2-different-databases")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28118902/spring-boot-remote-configuration") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28118902/spring-boot-remote-configuration")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28122565/how-to-get-the-flyway-bean") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28122565/how-to-get-the-flyway-bean")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28123299/spring-boot-module-based-integration-testing") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28123299/spring-boot-module-based-integration-testing")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/23521280/spring-data-rest-configure-pagination") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/23521280/spring-data-rest-configure-pagination")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28134883/spring-boot-using-a-service-in-quartz-job-execution") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28134883/spring-boot-using-a-service-in-quartz-job-execution")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28146805/spring-boot-jar-cannot-find-index-html") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28146805/spring-boot-jar-cannot-find-index-html")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28151529/spring-boot-using-standalone-tomcat-with-jndi-oracle-data-source") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28151529/spring-boot-using-standalone-tomcat-with-jndi-oracle-data-source")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28157778/spring-boot-date-handling-in-application-yaml-and-properties") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28157778/spring-boot-date-handling-in-application-yaml-and-properties")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://spring.io/blog/2014/03/07/deploying-spring-boot-applications") {
                org.jetbrains.compose.web.dom.Text("http://spring.io/blog/2014/03/07/deploying-spring-boot-applications")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://docs.spring.io/spring-boot/docs/current/reference/html/boot-features-spring-application.html") {
                org.jetbrains.compose.web.dom.Text("http://docs.spring.io/spring-boot/docs/current/reference/html/boot-features-spring-application.html")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28100100/spring-boot-configure-test-database") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28100100/spring-boot-configure-test-database")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28181594/spring-cloud-conifg-how-do-we-see-this-being-used") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28181594/spring-cloud-conifg-how-do-we-see-this-being-used")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28177501/spring-integration-read-file-by-name") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28177501/spring-integration-read-file-by-name")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28168108/preauthorize-on-a-nested-method-in-spring-controller") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28168108/preauthorize-on-a-nested-method-in-spring-controller")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28205673/add-request-interceptor-outside-of-web-mvc-configuration-class") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28205673/add-request-interceptor-outside-of-web-mvc-configuration-class")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28228068/spring-boot-full-rest-crud-example") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28228068/spring-boot-full-rest-crud-example")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28234324/how-to-load-spring-boot-based-rest-application-properties-from-a-different-file") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28234324/how-to-load-spring-boot-based-rest-application-properties-from-a-different-file")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28374000/spring-programmatically-generate-a-set-of-beans") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28374000/spring-programmatically-generate-a-set-of-beans")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28392231/how-to-determine-programmatically-the-current-active-profile-using-spring-boot") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28392231/how-to-determine-programmatically-the-current-active-profile-using-spring-boot")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28452400/how-to-enable-taskscheduler-in-spring-boot") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28452400/how-to-enable-taskscheduler-in-spring-boot")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28203130/how-to-deploy-and-access-springboot-war-with-tomcat-using-getting-started-gu") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28203130/how-to-deploy-and-access-springboot-war-with-tomcat-using-getting-started-gu")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28275448/multiple-data-source-and-schema-creation-in-spring-boot") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28275448/multiple-data-source-and-schema-creation-in-spring-boot")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28293533/thymeleaf-and-static-content") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28293533/thymeleaf-and-static-content")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28774903/spring-boot-thymeleaf-with-xml-templates") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28774903/spring-boot-thymeleaf-with-xml-templates")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28767966/how-to-create-spring-properties-by-condition") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28767966/how-to-create-spring-properties-by-condition")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28311423/enabling-spring-security-makes-swagger-output-text-plain-instead-of-html") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28311423/enabling-spring-security-makes-swagger-output-text-plain-instead-of-html")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28306031/apparent-spring-boot-race-condition-causing-duplicate-springsecurityfilterchain") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28306031/apparent-spring-boot-race-condition-causing-duplicate-springsecurityfilterchain")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28724894/spring-configuration-xml-and-properties-out-of-war") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28724894/spring-configuration-xml-and-properties-out-of-war")
            }
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("spring-boot-mvc") }) {
        org.jetbrains.compose.web.dom.Text("Spring (Boot) MVC")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28449589/define-parameterizableviewcontroller-to-auto-redirect-path-url-with-view") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28449589/define-parameterizableviewcontroller-to-auto-redirect-path-url-with-view")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28450276/spring-boot-freemarker-mvc-unit-tests-csrf") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28450276/spring-boot-freemarker-mvc-unit-tests-csrf")
            }
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("spring-boot-testing") }) {
        org.jetbrains.compose.web.dom.Text("Spring (Boot) Testing")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28418071/how-to-override-config-value-from-propertysource-used-in-a-configurationproper") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28418071/how-to-override-config-value-from-propertysource-used-in-a-configurationproper")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28694536/make-spring-boot-recreate-test-databases") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28694536/make-spring-boot-recreate-test-databases")
            }
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("camunda-spring") }) {
        org.jetbrains.compose.web.dom.Text("Camunda/Spring")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://docs.camunda.org/7.2/guides/user-guide/#spring-framework-integration") {
                org.jetbrains.compose.web.dom.Text("http://docs.camunda.org/7.2/guides/user-guide/#spring-framework-integration")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://docs.camunda.org/7.2/guides/installation-guide/tomcat/#bpm-platform") {
                org.jetbrains.compose.web.dom.Text("http://docs.camunda.org/7.2/guides/installation-guide/tomcat/#bpm-platform")
            }
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("sb-jndi") }) {
        org.jetbrains.compose.web.dom.Text("SB JNDI")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28131577/spring-boot-using-embedded-tomcat-with-jndi") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28131577/spring-boot-using-embedded-tomcat-with-jndi")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/27822619/howto-use-jndi-database-connection-with-spring-boot-and-spring-data-using-embedd/27825078#27825078") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/27822619/howto-use-jndi-database-connection-with-spring-boot-and-spring-data-using-embedd/27825078#27825078")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28118271/src-main-resources-file-overwritten-by-src-test-resources") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28118271/src-main-resources-file-overwritten-by-src-test-resources")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://projects.spring.io/spring-cloud/") {
                org.jetbrains.compose.web.dom.Text("http://projects.spring.io/spring-cloud/")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("vaadin") }) {
        org.jetbrains.compose.web.dom.Text("Vaadin")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/questions/28876894/how-to-create-user-authentication-on-vaadin") {
                org.jetbrains.compose.web.dom.Text("http://stackoverflow.com/questions/28876894/how-to-create-user-authentication-on-vaadin")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("osx") }) {
        org.jetbrains.compose.web.dom.Text("OSX")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://www.maceinsteiger.de/how-to/festplatte-verschlusseln/") {
                org.jetbrains.compose.web.dom.Text("http://www.maceinsteiger.de/how-to/festplatte-verschlusseln/")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("github") }) {
        org.jetbrains.compose.web.dom.Text("Github")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://git.io/") {
                org.jetbrains.compose.web.dom.Text("Git.io URL Shortener")
            }
        }
    }
}
